// config.tsx

class Config{
    name: string;
    version: string;
    
    url: string;
    backendUrl: string;

    constructor() {
        this.name = 'Personal Financial Dashboard'
        this.version = 'v1.0.0-beta'

        this.url = process.env.REACT_APP_URL || 'localhost:3000';
        this.backendUrl = process.env.REACT_APP_BACKEND_URL || 'localhost:3001';

        if (!this.url || !this.backendUrl) {
            throw new Error('Missing REACT_APP_URL/REACT_APP_BACKEND_URL in environment variables.')
        }
    }
}

const config = new Config();
export default config;